"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParticipantGallery1Schema = void 0;
exports.ParticipantGallery1Schema = {
    "$id": "https://www.redbull.com/schemas/content/ext/services/participant-gallery/1.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "ParticipantGallery1",
    "description": "An Embed for the Participant Gallery, which is a centralized image space with automatic participant tagging, enabling easy access and sharing of event photos. See https://participantgalleryapp.redbull.com/",
    "type": "object",
    "additionalProperties": false,
    "properties": {
        "type": {
            "const": "rrn:content:ext:services:participant-gallery:1"
        },
        "attributes": {
            "type": "object",
            "additionalProperties": false,
            "properties": {
                "id": {
                    "type": "string"
                }
            },
            "required": [
                "id"
            ]
        }
    },
    "required": [
        "attributes",
        "type"
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiMS5zY2hlbWEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi8uLi9zcmMvbW9kdWxlcy9jb250ZW50L2V4dC9zZXJ2aWNlcy9wYXJ0aWNpcGFudC1nYWxsZXJ5LzEuc2NoZW1hLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFhLFFBQUEseUJBQXlCLEdBQUc7SUFDdkMsS0FBSyxFQUFFLHdGQUF3RjtJQUMvRixTQUFTLEVBQUUsOENBQThDO0lBQ3pELE9BQU8sRUFBRSxxQkFBcUI7SUFDOUIsYUFBYSxFQUFFLCtNQUErTTtJQUM5TixNQUFNLEVBQUUsUUFBUTtJQUNoQixzQkFBc0IsRUFBRSxLQUFLO0lBQzdCLFlBQVksRUFBRTtRQUNaLE1BQU0sRUFBRTtZQUNOLE9BQU8sRUFBRSxnREFBZ0Q7U0FDMUQ7UUFDRCxZQUFZLEVBQUU7WUFDWixNQUFNLEVBQUUsUUFBUTtZQUNoQixzQkFBc0IsRUFBRSxLQUFLO1lBQzdCLFlBQVksRUFBRTtnQkFDWixJQUFJLEVBQUU7b0JBQ0osTUFBTSxFQUFFLFFBQVE7aUJBQ2pCO2FBQ0Y7WUFDRCxVQUFVLEVBQUU7Z0JBQ1YsSUFBSTthQUNMO1NBQ0Y7S0FDRjtJQUNELFVBQVUsRUFBRTtRQUNWLFlBQVk7UUFDWixNQUFNO0tBQ1A7Q0FDRixDQUFBIn0=